import React, { useMemo } from 'react';
import './InfoBox.css';
import { connect } from 'react-redux';
import {
  displayAlert,
  toggleDisplays,
} from '../state/uiControl/uiControl.actions';

import { change24HourTo12 } from '../util';
import { RootState } from 'typesafe-actions';
import { BlogEntry } from './ui-types';
import Box from './Box';

// Component for displaying blog entries on desktop view
export const InfoBox: React.FC<InfoBoxProps> = ({
  selected,
  toggleDisplays,
  data,
  displayAlert,
  selectedImage,
  selectedVoyage,
}) => {

  const selectedIndex = useMemo(() => {
    return data.findIndex((entry) => entry.id === selected?.id);
  }, [data, selected]);

  if (selectedIndex < 0 || !selected) {
    return null;
  }

  const entryToShow: BlogEntry = {
    content: "",
    time: change24HourTo12(selected.data.time),
    title: selected.name,
    latLong: ""
  };

  if (selected.data.content) {
    entryToShow.content = selected.data.content;
  }
  if (selected.data.author) {
    entryToShow.content += "\n " + selected.data.author;
  }
  if (typeof selected.lat !== "undefined" && typeof selected.long !== "undefined") {
    entryToShow.latLong = "Latitude: " + selected.lat?.toFixed(2) +
        "° Longitude: " + selected?.long?.toFixed(2) + "°";
  }

  function showNeighbourEntry (direction: number) {
    const neighbourIndex = selectedIndex + direction;
    const neighbourEntry = data[Math.min(Math.max(neighbourIndex, 0), data.length - 1)];
    toggleDisplays(neighbourEntry);
  }

  const navigationProps = {
    hasPrevious: selectedIndex - 1 >= 0,
    hasNext: selectedIndex + 1 < data.length,
    onClickPrevious: () => showNeighbourEntry(-1),
    onClickNext: () => showNeighbourEntry(1),
  };

  const menuItems = selectedVoyage?.data?.video && [
    {text: 'Watch Video', onClick: () => window.open(selectedVoyage!.data.video!.link, '_blank')},
    {text: 'Download Video', onClick: () => window.open(selectedVoyage!.data.video!.downloadLink, '_blank')},
    {text: 'Copy Link to Share', onClick: () => {
      navigator.clipboard.writeText(selectedVoyage!.data.video!.link);
      displayAlert({message: 'Link copied!', severity: 'info'});
    }}
  ];

  return (
    <Box 
      selectedImage={selectedImage}
      textContentProps={entryToShow}
      menuItems={menuItems}
      navigationProps={navigationProps}
    /> 
  );
};

const mapStateToProps = (state: RootState,) => {
  return {
    data: state.voyagesData.selectedVoyageEntries,
    selected: state.uiControl.selectedEntry,
    selectedImage: state.uiControl.selectedImage,
    selectedVoyage: state.voyagesData.selectedVoyageData,
  };
};

const dispatchProps = {
  toggleDisplays,
  displayAlert,
};

type InfoBoxProps = ReturnType<typeof mapStateToProps> & typeof dispatchProps;

export default connect(
  mapStateToProps,
  dispatchProps
)(InfoBox);